import { render, staticRenderFns } from "./AgendaOrList.vue?vue&type=template&id=2a2ad715&scoped=true&"
import script from "./AgendaOrList.vue?vue&type=script&lang=js&"
export * from "./AgendaOrList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2ad715",
  null
  
)

export default component.exports